export default {
  plans: {
    title: "Packages",
    subscription: {
      tabTitle: "Subscriptions",
      remaining: {
        label: "Remaining",
      },
      duration: {
        label: "Duration",
        unit: "days",
      },
      used: {
        label: "Used",
      },
      nextQuaterAllocation: {
        label: "Next allocation",
      },
      contractTitle: {
        myContract: "My contract",
        agency: "Agency contract",
        branch: "Branch contract",
      },
      contractDescription:
        "Unused upgrades and listings will expire by {expiryDate}",
      noInventory: {
        title: "You have no contract subscription details.",
        message:
          "Please speak with your office administration if you have questions about your subscription access.",
      },
      showMoreLabel: "Show more",
      hideMoreLabel: "Show less",
      startDate: "Due",
    },
    allocation: {
      tabTitle: "Allocations",
      contractTitle: {
        agency: "Allocations from agency contract",
        branch: "Allocations from branch contract",
      },
      remaining: {
        label: "Remaining",
      },
      duration: {
        label: "Duration",
        unit: "days",
      },
      used: {
        label: "Used",
      },
      allocation: {
        label: "Allocated",
      },
      contractDescription:
        "Unused upgrades and listings will expire by {expiryDate}",
      noInventory: {
        title:
          "Sorry but you don’t have the ability to access and transfer allocations.",
        message:
          "If you want to enable this function, please speak to your office administration or squarefoot customer service for details.",
      },
      showMoreLabel: "Show more",
      hideMoreLabel: "Show less",
      startDate: "Due",
    },
  },
};
